import { createTheme } from "@material-ui/core";
import { Colors } from "constants/constants";

const theme = createTheme({
  overrides: {
    MuiDialogActions: { root: {
      borderTop: "#BEBFC0 1px solid",
      padding: "16px 24px"
    }},
    MuiAlert: {
      root: {
        "& .MuiSelect-root": {
          padding: "5px 8px",
        },
      },
    },
    MuiMenu: {
      paper: {
        width: 220,
        boxShadow: "0px 1px 3px 0px #0000004D, 0px 4px 8px 3px #00000026",
      },
    },
    MuiListItemIcon: {
      root: {
        "& svg": {
          color: "#0E1011 !important",
        },
        marginRight: 16,
        minWidth: "fit-content",
      },
    },
    MuiInput: {
      input: {
        lineHeight: 1.5,
        padding: "12px 16px",
      },
    },
    MuiOutlinedInput: {
      root: {
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#0129FA",
        },
      },
      input: {
        padding: "10.5px 14px",
        height: 19,
        borderRadius: 4,
        border: "1px solid #828487 !important",
        "&:hover": {
          background: "#f0f0f063",
        },
        "&::before, &::after": {
          display: "none",
        },
      },
      multiline: {
        padding: 0,
        height: "100% !important",
      },
      inputMultiline: {
        padding: "10.5px 14px",
      },
    },
    MuiCheckbox: {
      colorSecondary: {
        "&.Mui-checked": {
          color: "#0129FA",
        },
      },
    },
    MuiSwitch: {
      switchBase: {
        "&.Mui-checked": {
          color: "#0129FA !important",
          "& + .MuiSwitch-track": {
            backgroundColor: "#0129FA !important",
          },
        },
      },
    },
    MuiFormControlLabel: {
      root: {
        color: "#0129FA",
        "& .MuiCheckbox-colorSecondary.Mui-checked": {
          color: "#0129FA",
        },
      },
    },
    MuiSelect: {
      selectMenu: {
        height: 19,
        display: "flex",
        alignItems: "center",
      },
    },
    MuiListItem: {
      root: {
        width: "100% !important",
        padding: "4px 8px",
        "&.MuiMenuItem-root:hover, &.MuiMenuItem-root.Mui-selected, &.MuiMenuItem-root.Mui-selected:hover, &.Mui-selected:hover":
          {
            backgroundColor: "#0129FA33",
            color: "#0E1011",
          },
        "& .MuiSvgIcon-root, & .MuiCheckbox-colorSecondary.Mui-checked": {
          color: "#0129FA",
        },
        "&.deleteMenuItem .MuiListItemText-root span, &.deleteMenuItem .MuiListItemIcon-root svg": {
          color: "#C42020 !important",
        },
      },
    },
    MuiPickersDay: {
      root: {
        "&.Mui-selected": {
          backgroundColor: "#9c27b0",
          color: "#fff",
        },
      },
    },
    MuiTableContainer: {
      root: {
        overflow: "auto",

        "&::-webkit-scrollbar": {
          width: "8px",
          height: "8px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: Colors.LIGHT_BLUE,
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: Colors.MAIN_LIGHT,
          borderRadius: "5px",
        },
      },
    },
    MuiTablePagination: {
      root: {
        overflow: "auto",

        "&::-webkit-scrollbar": {
          width: "8px",
          height: "8px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: Colors.LIGHT_BLUE,
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: Colors.MAIN_LIGHT,
          borderRadius: "5px",
        },
      },
    },
    MuiTableCell: {
      root: {
        padding: "5px",
        textAlign: "start",
      },
    },
    MuiTableRow: {
      root: {
        background: Colors.WHITE,
      },
    },
    MuiDialog: {
      paper: {
        borderRadius: "25px",
      },
    },
    MuiTable: {
      stickyHeader: {
        background: Colors.WHITE,
      },
      root: {
        border: "none",
      },
    },
    MuiButton: {
      root: {
        textTransform: "none",
        borderRadius: "25px",
      },
    },
    MuiIconButton: {
      root: {
        padding: "5px",
      },
    },
    MuiMenuItem: {
      root: {
        "&:hover": {
          background: Colors.MAIN,
          color: Colors.WHITE,
        },
        "&$selected": {
          background: Colors.MAIN_DARK,
          color: Colors.WHITE,
          "&:hover": {
            background: Colors.MAIN,
            color: Colors.WHITE,
          },
        },
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: 14,
        backgroundColor: "#333333c0",
        color: "#ffffff",
      },
    },
  },
  palette: {
    primary: {
      main: Colors.NEW_MAIN,
    },
    background: {
      default: "#EDF2F7",
    },
  },
  shadows: [
    "none",
    "0 0 0 1px rgba(63,63,68,0.05), 0 1px 2px 0 rgba(63,63,68,0.15)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 2px 2px -2px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 4px 8px -2px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 5px 8px -2px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 6px 12px -4px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 7px 12px -4px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 6px 16px -4px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 7px 16px -4px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 8px 18px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 9px 18px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 10px 20px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 11px 20px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 12px 22px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 13px 22px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 14px 24px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 16px 28px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 18px 30px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 20px 32px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 22px 34px -8px rgba(0,0,0,0.25)",
    "0 0 1px 0 rgba(0,0,0,0.31), 0 24px 36px -8px rgba(0,0,0,0.25)",
  ],
  typography: {
    fontFamily: ["Inter"],
    h1: {
      fontWeight: 700,
      fontSize: 30,
      letterSpacing: "-0.24px",
    },
    h2: {
      fontWeight: 600,
      fontSize: 26,
      letterSpacing: "-0.24px",
    },
    h3: {
      fontWeight: 600,
      fontSize: 24,
      letterSpacing: "-0.06px",
    },
    h4: {
      fontWeight: 600,
      fontSize: 20,
      letterSpacing: "-0.06px",
    },
    h5: {
      fontWeight: 500,
      fontSize: 18,
      letterSpacing: "-0.05px",
    },
    h6: {
      fontWeight: 500,
      fontSize: 16,
      letterSpacing: "-0.05px",
    },
    overline: {
      fontWeight: 500,
    },
    body1: {
      fontWeight: 400,
      fontSize: 16,
      letterSpacing: "-0.05px",
      color: "#0E1011",
      "&.boldFont": {
        fontWeight: 500,
      }
    },
    body2: {
      fontWeight: 500,
      fontSize: 14,
      letterSpacing: "-0.05px",
    },
  },
});

export default theme;
